import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { PureButton, PureLink } from '../../basics';
import { RenderType } from '../../enums';
import styles from './CategoryPill.module.scss';
const CategoryPill = forwardRef(({ a11yText, as, children, className, ...restProps }, componentRef) => {
    const classNameList = classNames(className, 'd-inline-block', styles.categoryPill);
    if (as === RenderType.Button) {
        return (_jsxs(PureButton, { className: classNameList, ref: componentRef, ...restProps, children: [a11yText && _jsx("span", { className: "screenReaderOnly", children: a11yText }), children] }));
    }
    return (_jsxs(PureLink, { className: classNameList, ref: componentRef, ...restProps, children: [a11yText && _jsx("span", { className: "screenReaderOnly", children: a11yText }), children] }));
});
CategoryPill.displayName = CategoryPill.name;
export { CategoryPill };
